import React, {useEffect, useState} from 'react';
import {ProductPageDownloadCategoryModel} from "../../product-models";
import {useCollapse} from "react-collapsed";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {collapseDownloadCategory, expandDownloadCategory} from "../../store/actionCreators/downloadDisplayManagement";

interface DownloadsCategoryProps {
    category: string;
}

const DownloadsCategory = React.memo((props:DownloadsCategoryProps) => {
    const dispatch = useDispatch();

    const { productData} = useTypedSelector((state) => state.product);
    //Use state here to keep the category data in, rather than keep doing a find on the product data every time we need data from it
    const [catData, setCatData] = useState<ProductPageDownloadCategoryModel>(null);
    
    useEffect(() => {
        setCatData(productData.ProductFiles.find((dlCat) => dlCat.CategoryName == props.category))
    }, [productData])
    
    const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded: catData != null && catData.IsExpanded })
    
    const toggleCollapseExpand = () => {
        if(catData.IsExpanded) {
            dispatch(collapseDownloadCategory(catData.CategoryName));
        } else {
            console.log("EXPANDING");
            dispatch(expandDownloadCategory(catData.CategoryName));
        }
    }

    if(catData == null) {
        return null;
    }

    return (
        <>
            <h3 {...getToggleProps({
                onClick: () => toggleCollapseExpand(),
            })}
            >
                <span className={catData.IsExpanded? 'open-close-icon open' : 'open-close-icon close'}></span>
                {catData.DdFullname}
            </h3>

            <section {...getCollapseProps()}>
                <ul>
                {catData.Downloads.map((download, index) => {
                    return (
                        <li key={index}>
                            <a href={download.DlUrl} target="_blank">{download.DlTitle}</a>
                        </li>
                    )
                })}
                </ul>
            </section>
        </>
    )
})

export default DownloadsCategory